import { type PublicClip } from '@air/api';
import { type AssetCustomFieldValue, type BoardCustomFieldValue, type ShortUrlForm } from '@air/api/types';
import { type Upload } from '@air/redux-uploader';

export type ContentCollectionCustomField = Omit<AssetCustomFieldValue & BoardCustomFieldValue, 'assetId' | 'boardId'>;

export enum ContentCollectionView {
  Onboarding = 'onboarding',
  Manage = 'manage',
  Completed = 'completed',
  AutoSubmit = 'autoSubmit',
}

export type ContentCollectionAssetAutoSubmitStatus =
  | { status: 'pending' }
  | { status: 'success' }
  | {
      status: 'failure';
      message: string;
      retryable: boolean;
    };
export interface ContentCollectionClip extends PublicClip {
  uploadId: Upload['id'];
  groupName: string;
  autoSubmit?: ContentCollectionAssetAutoSubmitStatus;
}

export type ContentCollectionClipWithUpload = ContentCollectionClip & { upload: Upload };

export type ContentCollectionState = {
  applyAll: boolean;
  customFields: ContentCollectionCustomField[];
  form: ShortUrlForm | undefined;
  sessionId?: string;
  attemptedSubmission: boolean;
  touched: boolean;
  clips: Record<string, ContentCollectionClip>;
  submittedClips: ContentCollectionClipWithUpload[];
  view: ContentCollectionView;
  formSubmissionRequired?: boolean;
  submitterName?: string;
};
